import apiClient from './authService';
import { AUTH_ENDPOINTS, API_BASE_URL } from '../utils/authConstants';

export const oauthService = {
  // Test function to verify OAuth parameters
  testOAuthParams: () => {
    const redirectUri = window.location.origin + '/auth/callback';
    const cognitoUrl = `https://us-east-1khp4rwjll.auth.us-east-1.amazoncognito.com/oauth2/authorize?` +
      `response_type=code&` +
      `client_id=3n1q6rddpobdtdaotiv80jo86c&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `scope=openid+email+profile+phone&` +
      `state=${Math.random().toString(36).substring(2, 15)}`;
    
    console.log('=== OAuth Parameter Test ===');
    console.log('Environment Variables:');
    console.log('  REACT_APP_COGNITO_DOMAIN:', process.env.REACT_APP_COGNITO_DOMAIN);
    console.log('  REACT_APP_COGNITO_CLIENT_ID:', process.env.REACT_APP_COGNITO_CLIENT_ID);
    console.log('');
    console.log('Generated Parameters:');
    console.log('  window.location.origin:', window.location.origin);
    console.log('  redirectUri:', redirectUri);
    console.log('  encoded redirectUri:', encodeURIComponent(redirectUri));
    console.log('  Final Cognito URL:', cognitoUrl);
    console.log('');
    console.log('=== FRONTEND DIRECT OAUTH FLOW ===');
    console.log('1. Frontend → Cognito:');
    console.log('   Redirect to:', cognitoUrl);
    console.log('');
    console.log('2. Cognito → Frontend:');
    console.log('   Cognito redirects to:', redirectUri);
    console.log('   With query params: ?code=...&state=...');
    console.log('');
    console.log('3. Frontend → Backend:');
    console.log('   POST /api/auth/oauth/verify');
    console.log('   Body: { code, state, redirect_uri:', redirectUri, '}');
    console.log('');
    console.log('4. Backend → Frontend:');
    console.log('   Backend verifies with Cognito → Generates JWT → Returns tokens');
    console.log('');
    console.log('5. Frontend:');
    console.log('   Stores JWT tokens → Works exactly like regular /login');
    console.log('============================');
    
    return {
      redirectUri,
      encodedRedirectUri: encodeURIComponent(redirectUri),
      cognitoUrl
    };
  },

  // Initiate OAuth login (frontend builds Cognito URL directly)
  initiateLogin: (redirectUri = window.location.origin + '/auth/callback') => {
    console.log('OAuth Service - Initiating OAuth login (Frontend Direct)');
    console.log('OAuth Service - Current origin:', window.location.origin);
    console.log('OAuth Service - Redirect URI:', redirectUri);
    
    // Build Cognito OAuth URL directly (no backend needed)
    const cognitoUrl = `https://us-east-1khp4rwjll.auth.us-east-1.amazoncognito.com/oauth2/authorize?` +
      `response_type=code&` +
      `client_id=3n1q6rddpobdtdaotiv80jo86c&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `scope=openid+email+profile+phone&` +
      `state=${Math.random().toString(36).substring(2, 15)}`;
    
    console.log('OAuth Service - Cognito OAuth URL:', cognitoUrl);
    console.log('OAuth Service - Redirecting directly to Cognito hosted UI');
    console.log('============================');
    
    // Redirect directly to Cognito hosted UI
    window.location.href = cognitoUrl;
  },

  // Handle OAuth callback from Cognito
  handleCallback: async (code, state) => {
    try {
      console.log('OAuth callback received - code:', code, 'state:', state);
      console.log('OAuth Service - Making verification request to:', `${AUTH_ENDPOINTS.OAUTH.VERIFY}`);
      console.log('OAuth Service - Callback redirect_uri:', window.location.origin + '/auth/callback');
      
      const response = await apiClient.post(AUTH_ENDPOINTS.OAUTH.VERIFY, {
        code,
        state,
        redirect_uri: window.location.origin + '/auth/callback'
      });
      
      console.log('OAuth verification response:', response.data);
      
      if (response.data.success) {
        return response.data;
      }
      
      throw new Error(response.data.error || 'OAuth verification failed');
    } catch (error) {
      console.error('OAuth service error:', error);
      throw error;
    }
  },

  // Get OAuth user info
  getUserInfo: async () => {
    try {
      const response = await apiClient.get(AUTH_ENDPOINTS.OAUTH.USER_INFO);
      return response.data;
    } catch (error) {
      console.error('Error getting OAuth user info:', error);
      throw error;
    }
  },

  // Check OAuth status
  checkStatus: async () => {
    try {
      const response = await apiClient.get(AUTH_ENDPOINTS.OAUTH.STATUS);
      return response.data;
    } catch (error) {
      console.error('Error checking OAuth status:', error);
      throw error;
    }
  },

  // OAuth logout
  logout: async () => {
    try {
      const response = await apiClient.post(AUTH_ENDPOINTS.OAUTH.LOGOUT);
      return response.data;
    } catch (error) {
      console.error('Error during OAuth logout:', error);
      throw error;
    }
  }
};